import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrieveLeague } from "../api/LeagueApiProvider";
import { useDeactivateVenueFromLeague, useListLeagueHomeVenues, useRemoveVenueFromLeague, } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { ManageVenueAssociations } from "../venues/ManageVenueAssociations";
export const ManageLeagueVenues = () => {
    const { id } = useNumericParams();
    const { data: league, isLoading, error } = useRetrieveLeague({ id });
    const { data: permissions, isLoading: isPermsLoading, error: permsError, } = useRetrieveUserLeaguePermissions({
        leagueId: id,
    });
    const { canView = false, canModify = false } = permissions || {};
    const { data: venues, isLoading: isVenuesLoading, error: venuesError, } = useListLeagueHomeVenues({ leagueId: id, enabled: canView });
    const deactivateMutation = useDeactivateVenueFromLeague({
        leagueId: id,
        onSuccess: () => { },
        onError: () => { },
    });
    const removeMutation = useRemoveVenueFromLeague({
        leagueId: id,
        onSuccess: () => { },
        onError: () => { },
    });
    const handleDeactivate = (venueAssociationId, toDate) => {
        deactivateMutation.mutate({
            leagueVenueId: venueAssociationId,
            toDate,
        });
    };
    const handleRemove = (venueAssociationId) => {
        removeMutation.mutate(venueAssociationId);
    };
    if (!id) {
        return _jsx(NotFound, {});
    }
    if (isLoading || isPermsLoading || isVenuesLoading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (error || !league || permsError || venuesError) {
        return (_jsx(ErrorView, { error: error ||
                permsError ||
                venuesError ||
                new Error("Failed to load league or venues.") }));
    }
    return (_jsx(ManageVenueAssociations, { entityName: "league", entityDisplayName: league.name, entityId: id, venues: venues || [], addVenueUrl: `/leagues/${id}/venues/add/`, deactivateMutation: deactivateMutation, removeMutation: removeMutation, onDeactivate: handleDeactivate, onRemove: handleRemove }));
};
